import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {
  FullCalendarComponent
} from 'projects/desktop/src/app/modules/full-calendar/full-calendar/full-calendar.component';
import {ProjectsListComponent} from './modules/project/view/projects-list/projects-list.component';
import {NotificationPageComponent} from './view/notification/notification-page/notification-page.component';
import {CustomersListComponent} from './modules/customer/view/customers-list/customers-list.component';
import {AlertsListComponent} from './modules/alerts/alerts-list/alerts-list.component';
import {ApprovalsPageComponent} from './modules/timesheets/view/timesheets/approvals-page/approvals-page.component';
import {MainViewComponent} from './modules/kanban-board/main-view/main-view.component';
import {AvatarsTestComponent} from './view/test/avatars-test/avatars-test.component';
import {UsersPageComponent} from 'projects/app-misc/src/app/modules/users/view/users-page/users-page.component';
import {
  TicketsTestsPageComponent
} from 'projects/app-misc/src/app/tests-page/view/tickets-tests-page/tickets-tests-page.component';
import {VendorsPageComponent} from './modules/vendor/view/vendors-page/vendors-page.component';
import {OrdersPageComponent} from './modules/order/view/orders-page/orders-page.component';
import {MaterialsPageComponent} from './modules/vendor/view/materials-page/materials-page.component';
import {ClientNfsPageComponent} from './view/notification/client-nfs-page/client-nfs-page.component';
import {HomeBoardComponent} from './modules/home-page/view/home-board/home-board.component';
import {VacationCalendarComponent} from './modules/timesheets/view/vacation-calendar/vacation-calendar.component';
import {
  ReportsViewComponent
} from 'projects/app-misc/src/app/modules/reports/view/reports-view/reports-view.component';
import {
  CabinetReportsViewComponent
} from 'projects/app-misc/src/app/modules/reports/view/project-complexity-reports/project-complexity-reports-view/cabinet-reports-view.component';
import {
  AdminPanelComponent
} from 'projects/app-misc/src/app/modules/admin-panel/view/admin-panel/admin-panel.component';
import {CanUserActivateRouteGuard} from 'projects/core/src/lib/login/data/can-user-activate-route-guard';
import {
  AccessEditorComponent
} from 'projects/app-misc/src/app/modules/admin-panel/view/access-editor/access-editor.component';
import {
  DictionariesEditorComponent
} from 'projects/app-misc/src/app/modules/admin-panel/view/dictionaries-editor/dictionaries-editor.component';
import {
  EmailChangerComponent
} from 'projects/app-misc/src/app/modules/admin-panel/view/email-changer/email-changer.component';
import {
  ActivitiesEditorComponent
} from 'projects/app-misc/src/app/modules/admin-panel/view/activities-editor/activities-editor.component';
import {
  KbColumnEditorComponent
} from '../../../app-misc/src/app/modules/admin-panel/view/kb-column-editor/kb-column-editor.component';
import {
  SystemNfsChangerComponent
} from 'projects/app-misc/src/app/modules/admin-panel/view/system-nfs-changer/system-nfs-changer.component';
import {
  TimesheetsPageComponent
} from 'projects/desktop/src/app/modules/timesheets/view/timesheets/timesheets-page/timesheets-page.component';
import {GraphsViewComponent} from 'projects/app-misc/src/app/modules/reports/view/graphs-view/graphs-view.component';
import {
  CabinetsComplexityViewComponent
} from 'projects/app-misc/src/app/modules/reports/view/cabinets-complexity-view/cabinets-complexity-view.component';
import {
  ProjectComplexityViewComponent
} from 'projects/app-misc/src/app/modules/reports/view/project-complexity-view/project-complexity-view.component';
import {
  ProjectOverallPriceViewComponent
} from 'projects/app-misc/src/app/modules/reports/view/project-overall-price-view/project-overall-price-view.component';
import {MentionPageComponent} from 'projects/desktop/src/app/view/notification/mention-page/mention-page.component';
import {
  ItemEditorComponent
} from 'projects/app-misc/src/app/modules/admin-panel/view/item-editor/item-editor.component';
import {
  GradeEditorComponent
} from '../../../app-misc/src/app/modules/admin-panel/view/grade-editor/grade-editor.component';
import {
  PricingCategoriesEditorComponent
} from '../../../app-misc/src/app/modules/admin-panel/view/pricing-categories-editor/pricing-categories-editor.component';
import {
  PricingModifEditorComponent
} from '../../../app-misc/src/app/modules/admin-panel/view/pricing-modif-editor/pricing-modif-editor.component';
import {
  ProjectStatReportsComponent
} from '../../../app-misc/src/app/modules/reports/view/project-stat-reports/project-stat-reports.component';
import {
  ProductionPlanningCalendarComponent
} from '../../../app-misc/src/app/modules/production-planning/view/production-planning-calendar/production-planning-calendar.component';
import { E } from '@angular/cdk/keycodes';
import { ActivityEngineeringComponent } from 'projects/app-misc/src/app/modules/production-planning/view/production-planning-calendar/activity-engineering/activity-engineering.component';
import {UserScheduleComponent} from './modules/full-calendar/user-schedule/user-schedule.component';

const routes: Routes = [{
  path: '*',
  component: HomeBoardComponent,
  pathMatch: 'full'
}, {
  path: '',
  component: HomeBoardComponent,
  pathMatch: 'full'
}, {
  path: 'home',
  component: HomeBoardComponent,
  canActivate: [CanUserActivateRouteGuard],
  data: {
    allowedRolesPath: '/home'
  }
}, {
  path: 'project/:id',
  component: HomeBoardComponent,
  canActivate: [CanUserActivateRouteGuard],
  data: {
    allowedRolesPath: '/projects'
  }
}, {
  path: 'pricing',
  loadChildren: () => import('../../../app-misc/src/app/modules/project-calc/project-calc.module').then(m => m.ProjectCalcModule),
  canActivate: [CanUserActivateRouteGuard],
  data: {
    allowedRolesPath: '/pricing'
  }
}, {
  path: 'logistic',
  loadChildren: () => import('../../../app-misc/src/app/modules/logistic-routes/logistic-routes.module').then(m => m.LogisticRoutesModule),
  canActivate: [CanUserActivateRouteGuard],
  data: {
    allowedRolesPath: '/logistic'
  }
}, {
  path: 'schedule',
  component: FullCalendarComponent,
  canActivate: [CanUserActivateRouteGuard],
  data: {
    allowedRolesPath: '/schedule'
  }
}, {
  path: 'user-schedule',
  component: UserScheduleComponent,
  canActivate: [CanUserActivateRouteGuard],
  data: {
    allowedRolesPath: '/user-schedule'
  }
}, {
  path: 'projects',
  component: ProjectsListComponent,
  canActivate: [CanUserActivateRouteGuard],
  data: {
    allowedRolesPath: '/projects'
  }
}, {
  path: 'production',
  component: ProductionPlanningCalendarComponent,
  canActivate: [CanUserActivateRouteGuard],
  data: {
    allowedRolesPath: '/production'
  }
}, {
  path: 'planning',
  component: ActivityEngineeringComponent,
  canActivate: [CanUserActivateRouteGuard],
  data: {
    allowedRolesPath: '/planning'
  }
}, {
  path: 'customers',
  component: CustomersListComponent,
  canActivate: [CanUserActivateRouteGuard],
  data: {
    allowedRolesPath: '/customers'
  }
}, {
  path: 'alerts',
  component: AlertsListComponent,
  canActivate: [CanUserActivateRouteGuard],
  data: {
    allowedRolesPath: '/alerts'
  }
}, {
  path: 'notifications',
  component: NotificationPageComponent
}, {
  path: 'mentions',
  component: MentionPageComponent
}, {
  path: 'timesheets',
  redirectTo: 'timesheets/approvals',
}, {
  path: 'timesheets',
  children: [{
    path: 'approvals',
    component: ApprovalsPageComponent
  }, {
    path: 'vacations',
    component: VacationCalendarComponent
  }],
  component: TimesheetsPageComponent,
  canActivate: [CanUserActivateRouteGuard],
  data: {
    allowedRolesPath: '/timesheets'
  }
}, {
  path: 'board',
  component: MainViewComponent,
  canActivate: [CanUserActivateRouteGuard],
  data: {
    allowedRolesPath: '/board'
  }
}, {
  path: 'users',
  component: UsersPageComponent,
  canActivate: [CanUserActivateRouteGuard],
  data: {
    allowedRolesPath: '/users'
  }
}, {
  path: 'reports',
  redirectTo: 'reports/charts'
}, {
  path: 'reports',
  component: ReportsViewComponent,
  children: [{
    path: 'charts',
    component: GraphsViewComponent
  }, {
    path: 'projects',
    component: ProjectStatReportsComponent
  }, {
    path: 'complexity',
    redirectTo: 'complexity/projects'
  }, {
    path: 'complexity',
    component: ProjectComplexityViewComponent,
    children: [{
      path: 'projects',
      component: CabinetReportsViewComponent
    }, {
      path: 'cabinets',
      component: CabinetsComplexityViewComponent
    }]
  }, {
    path: 'project-cost',
    component: ProjectOverallPriceViewComponent
  }],
  canActivate: [CanUserActivateRouteGuard],
  data: {
    allowedRolesPath: '/reports'
  }
}, {
  path: 'avatars-test/:id',
  component: AvatarsTestComponent
}, {
  path: 'tests-page',
  component: TicketsTestsPageComponent
}, {
  path: 'orders/list',
  component: OrdersPageComponent,
  canActivate: [CanUserActivateRouteGuard],
  data: {
    allowedRolesPath: '/orders/list'
  }
}, {
  path: 'orders/vendors',
  component: VendorsPageComponent,
  canActivate: [CanUserActivateRouteGuard],
  data: {
    allowedRolesPath: '/orders/list'
  }
}, {
  path: 'orders/materials',
  component: MaterialsPageComponent,
  canActivate: [CanUserActivateRouteGuard],
  data: {
    allowedRolesPath: '/orders/list'
  }
}, {
  path: 'client-nfs',
  component: ClientNfsPageComponent,
  canActivate: [CanUserActivateRouteGuard],
  data: {
    allowedRolesPath: '/client-nfs'
  }
}, {
  path: 'admin-panel',
  children: [{
    path: 'categories',
    component: PricingCategoriesEditorComponent
  }, {
    path: 'modifiers',
    component: PricingModifEditorComponent
  }, {
    path: 'grades',
    component: GradeEditorComponent
  }, {
    path: 'items',
    component: ItemEditorComponent
  }, {
    path: 'emails',
    component: EmailChangerComponent
  }, {
    path: 'dictionaries',
    component: DictionariesEditorComponent
  }, {
    path: 'activities',
    component: ActivitiesEditorComponent
  }, {
    path: 'kb-columns',
    component: KbColumnEditorComponent
  }, {
    path: 'nfs-alerts',
    component: SystemNfsChangerComponent
  }, {
    path: 'access',
    component: AccessEditorComponent
  }],
  component: AdminPanelComponent,
  canActivate: [CanUserActivateRouteGuard],
  data: {
    allowedRolesPath: '/admin-panel'
  }
}]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
